import React, { useState, useEffect, useContext } from "react";
import "./index.scss";
import {
  Box,
  Card,
  CardContent,
  FormControlLabel,
  Grid,
  Switch,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import { HTTP_METHODS, invokeApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import {
  formatAllInfoResponse,
  formatIndiaMapData,
} from "../../../components/overview/helper";
import Overview1 from "../../../components/overview/overview1";
import { DUMMY_STATE_DATA, INDIA_MAP_DATA } from "./helper";
import IndiaMap from "../../../core/india-map";
import AppContext from "../../../utils/context";
import { financialYears } from "../../../components/financial-year-calendar/helper";
import CustomBarChart from "../../../components/overview/bar-chart";
import DefectsTable from "./defect-table";
import { COST_ACCESS_EMAILS } from "../../../utils/constants";
import { formtHMRData } from "../../../components/overview/other-info";
import OemModelWiseSummary from "./oem-model-wise-summary";
import CustomPiChart from "../../../components/overview/pi-chart";

const AdminDashboard = () => {
  const [dashboardDetails, setDashboardDetails] = useState({});
  const [indiaMapData, setIndiaMapData] = useState({ ...INDIA_MAP_DATA });
  const [ticketCounts, setTicketCounts] = useState({});
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [serviceEngineerAgeing, setServiceEngineerAgeing] = useState([]);
  const [defectsData, setDefectsData] = useState({});
  const [isCallApis, setIsCallApis] = useState(false);
  const [partData, setPartData] = useState([]);
  const [hmrData, setHmrData] = useState([]);
  const [oemModelWiseData, setOemModelWiseData] = useState({});
  const [showAgeingOverview, setShowAgeingOverview] = useState(false);
  const [partReplacementViewType, setPartReplacementViewType] =
    useState("count");
  const [serviceEngineerAgeingStatus, setServiceEngineerAgeingStatus] =
    useState("OPENED");
  const { overviewDashboardFilter = {}, setOverviewDashboardFilter } =
    useContext(AppContext);
  const { userDetails = {} } = useContext(AppContext);

  const loadStateData = (params = {}) => {
    const payload = {
      ...params,
      ...overviewDashboardFilter,
    };
    loadData(payload);
    invokeApi(
      HTTP_METHODS.POST,
      `${HOSTNAME}${REST_URLS.DASHBOARD_STATE_WISE_DATA}`,
      payload
    )
      .then((res) => {
        if (!res.message) {
          const { hmrBucketCounts, oemOrgAndEngineModalCounts } = res;
          const result = res?.stateCounts
            ?.map((ele) => ({
              state: ele?._id,
              count: ele?.count,
            }))
            .filter((st) => st.state && st);
          setDashboardDetails((prevVal) => ({
            ...prevVal,
            stateWiseCounts2: result,
          }));
          setIndiaMapData((prevVal) => formatIndiaMapData(result, prevVal));

          // setIndiaMapData((prevVal) =>
          //   formatIndiaMapData(DUMMY_STATE_DATA, prevVal)
          // );
          //hrm data
          const hmrresult = hmrBucketCounts
            ?.map((ele) => ele?.bucket && ele)
            .filter((buc) => buc && buc);

          setHmrData(formtHMRData(hmrresult));

          //oem org model data
          setOemModelWiseData(oemOrgAndEngineModalCounts);
        }
      })
      .catch((err) => console.error(err));
  };
  const loadData = (payload) => {
    const params = { ...payload, ...overviewDashboardFilter };

    invokeApi(HTTP_METHODS.POST, `${HOSTNAME}${REST_URLS.DASHBOARD}`, params)
      .then((response) => {
        const formattedData = formatAllInfoResponse(response);
        setDashboardDetails((prevVal) => ({ ...prevVal, ...formattedData }));
      })
      .catch((err) => console.error(err));

    invokeApi(HTTP_METHODS.POST, `${HOSTNAME}${REST_URLS.TICKETS_COUNTS}`, {
      ...payload,
      ...overviewDashboardFilter,
    })
      .then((response) => {
        setTicketCounts(response);
      })
      .catch((err) => console.error(err));
  };
  const loadServiceEngineerAgeing = (params = {}) => {
    const payload = {
      ...params,
      ...overviewDashboardFilter,
      ticketStatus: [serviceEngineerAgeingStatus],
    };
    invokeApi(
      HTTP_METHODS.POST,
      `${HOSTNAME}${REST_URLS.SERVICE_ENG_AGEING}`,
      payload
    )
      .then((res) => {
        if (!res.message) {
          setServiceEngineerAgeing(res);
        }
      })
      .catch((err) => console.error(err));
  };
  const loadDefectData = (params = {}) => {
    const payload = {
      ...params,
      ...overviewDashboardFilter,
    };
    invokeApi(
      HTTP_METHODS.POST,
      `${HOSTNAME}${REST_URLS.TOP_5_DEFECT_CODE}`,
      payload
    )
      .then((res) => {
        if (!res.message) {
          setDefectsData(res);
        }
      })
      .catch((err) => console.error(err));
  };
  const loadPartData = (params = {}) => {
    const payload = {
      ...params,
      ...overviewDashboardFilter,
    };
    if (partReplacementViewType === "cost") {
      invokeApi(
        HTTP_METHODS.POST,
        `${HOSTNAME}${REST_URLS.DASHBOARD_PART_COST_DATA}`,
        payload
      )
        .then((response) => {
          if (!response.message) {
            const sortedRes = response.sort(
              (a, b) => b.totalCost - a.totalCost
            );
            setPartData(sortedRes);
          } else {
            setPartData([]);
          }
        })
        .catch((err) => console.error(err));
    } else {
      invokeApi(
        HTTP_METHODS.POST,
        `${HOSTNAME}${REST_URLS.DASHBOARD_PART_DATA}`,
        payload
      )
        .then((response) => {
          if (!response.message) {
            const sortedRes = response.sort((a, b) => b.count - a.count);
            setPartData(sortedRes);
          } else {
            setPartData([]);
          }
        })
        .catch((err) => console.error(err));
    }
  };
  // Effect to load filters from sessionStorage when component mounts
  useEffect(() => {
    const storedFilters = JSON.parse(sessionStorage.getItem("overviewFilters"));

    // If filters exist in sessionStorage, load them
    if (
      storedFilters &&
      storedFilters.length > 0 &&
      storedFilters?.length === Object.keys(overviewDashboardFilter)?.length
    ) {
      setSelectedFilters(storedFilters);
      setIsCallApis(true);
    } else {
      // If no filters in sessionStorage, set default filter
      sessionStorage.setItem("overviewFilters", JSON.stringify([]));
      const financialYear = financialYears?.[0];
      const defaultFilters = [
        {
          type: "status",
          value: { label: "Open", value: "OPENED" },
        },
        {
          type: "financialYear",
          value: {
            label: financialYear?.label,
            value: financialYear?.label,
          },
        },
      ];
      setSelectedFilters(defaultFilters);
      setOverviewDashboardFilter({
        status: ["OPENED"],
        financialYear: [financialYear?.label],
      });
      setIsCallApis(true);
    }
  }, []);
  // Save selected filters to sessionStorage whenever they change
  useEffect(() => {
    if (selectedFilters?.length > 0) {
      sessionStorage.setItem(
        "overviewFilters",
        JSON.stringify(selectedFilters)
      );
    }
    return () => {
      if (Object.keys(overviewDashboardFilter)?.length <= 0) {
        sessionStorage.setItem("overviewFilters", JSON.stringify([]));
      }
    };
  }, [selectedFilters]);

  // Effect to update filters when state filter is changed
  useEffect(() => {
    if (overviewDashboardFilter?.state) {
      setSelectedFilters((prevVal) => {
        const existingFilterIndex = prevVal.findIndex(
          (filter) => filter.type === "state"
        );
        if (existingFilterIndex !== -1) {
          const updatedFilters = [...prevVal];
          updatedFilters[existingFilterIndex] = {
            type: "state",
            value: overviewDashboardFilter?.state?.[0],
          };
          return updatedFilters;
        } else {
          return [
            ...prevVal,
            {
              type: "state",
              value: overviewDashboardFilter?.state?.[0],
            },
          ];
        }
      });
    } else {
      setSelectedFilters((prevVal) =>
        prevVal?.filter((filter) => filter.type !== "state")
      );
    }
  }, [overviewDashboardFilter]);
  useEffect(() => {
    if (isCallApis) {
      loadData();
      loadStateData();
      loadDefectData();
      loadPartData();
    }
  }, [overviewDashboardFilter, isCallApis]);
  useEffect(() => {
    if (isCallApis) {
      loadPartData();
    }
  }, [partReplacementViewType]);

  useEffect(() => {
    if (isCallApis && showAgeingOverview) {
      loadServiceEngineerAgeing();
    }
  }, [serviceEngineerAgeingStatus, showAgeingOverview]);

  return (
    <div className="page-body">
      <div>
        <p className="tab-name">Dashboard</p>
        <p className="section-name">Tickets Overview</p>
      </div>
      <Grid container spacing={2}>
        <Grid item md={6} sx={{ height: "auto" }}>
          <Card sx={{ height: "auto" }}>
            <CardContent>
              <IndiaMap
                data={indiaMapData}
                title="State wise overview"
                loadStateData={loadStateData}
                selectedFilters={selectedFilters}
                setSelectedFilters={setSelectedFilters}
                isOverview={true}
              />
            </CardContent>
          </Card>
          <Card sx={{ mt: 2, minHeight: "30%" }}>
            <CardContent>
              <FormControlLabel
                control={
                  <Switch
                    checked={showAgeingOverview}
                    onChange={() => setShowAgeingOverview((prev) => !prev)}
                    color="primary"
                  />
                }
                label="Show Service engineer wise complaint ageing"
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  mb: 2,
                }}
              />

              {showAgeingOverview ? (
                <>
                  <Box
                    sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}
                  >
                    <ToggleButtonGroup
                      value={serviceEngineerAgeingStatus}
                      exclusive
                      onChange={(_, newValue) => {
                        if (newValue) {
                          setServiceEngineerAgeingStatus(newValue);
                        }
                      }}
                      size="small"
                    >
                      <ToggleButton value="OPENED">Open</ToggleButton>
                      <ToggleButton value="CLOSED">Closed</ToggleButton>
                    </ToggleButtonGroup>
                  </Box>
                  <CustomBarChart
                    title="Service engineer wise complaint ageing"
                    data={serviceEngineerAgeing || []}
                    xDataKey="serviceEngineer"
                    bDataKey="ageing"
                    label="Avg Ageing in Days"
                    height={150}
                    tooltipFormatter={(item) => [
                      `Avg Ageing in Days: ${item.ageing} days`,
                      `Avg Ageing in Hours: ${item.ageInHours} hours`,
                      `No. of Tickets Open: ${item.openCount}`,
                    ]}
                  />
                </>
              ) : (
                <CustomPiChart
                  title="HMR counts overview"
                  data={hmrData}
                  xDataKey="bucket"
                  bDataKey="count"
                />
              )}
            </CardContent>
          </Card>
        </Grid>
        <Grid item md={6}>
          <Overview1
            dashboardDetails={dashboardDetails}
            ticketCounts={ticketCounts}
            isCallApis={isCallApis}
          />
        </Grid>
      </Grid>
      <Grid container sx={{ mt: 1 }} spacing={2}>
        <Grid item md={12}>
          <Card>
            <CardContent>
              <DefectsTable defectsData={defectsData} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item md={12} sx={{ mt: 2 }} xs={12} className="si-hide-mobile">
          <Card>
            <CardContent>
              <OemModelWiseSummary responseData={oemModelWiseData} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item md={12} xs={12} className="si-hide-mobile">
          <Card sx={{ mt: 2 }}>
            <CardContent>
              {COST_ACCESS_EMAILS?.includes(userDetails?.email) && (
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}
                >
                  <ToggleButtonGroup
                    value={partReplacementViewType}
                    exclusive
                    onChange={(_, newValue) => {
                      if (newValue) {
                        setPartReplacementViewType(newValue);
                      }
                    }}
                    size="small"
                  >
                    <ToggleButton value="count">Count Wise</ToggleButton>
                    <ToggleButton value="cost">Cost Wise</ToggleButton>
                  </ToggleButtonGroup>
                </Box>
              )}
              <CustomBarChart
                title="Part wise failure"
                data={partData || []}
                xDataKey="part"
                bDataKey={
                  partReplacementViewType === "cost" ? "totalCost" : "count"
                }
                showLabel={false}
                label={partReplacementViewType === "cost" ? "Cost" : "Count"}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};
export default AdminDashboard;
